import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const startCheckout = async (lookup_key, email = null, quantity = 1) => {
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    quantity,
    email,
    origin_url: window.location.origin,
  });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
};

export const getProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const sendLantern = async (payload) => {
  const { data } = await api.post("/lantern", payload);
  return data;
};

export const getLantern = async (code) => {
  const { data } = await api.get(`/lantern/${code}`);
  return data;
};
